import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import {
  PartnersDataTableItem,
  PartnerService,
} from 'src/app/services/partner/partner.service';
import { CreatePartnerDialogComponent } from './create-partner-dialog/create-partner-dialog.component';
import { EditPartnerDialogComponent } from './edit-partner-dialog/edit-partner-dialog.component';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { PayeeIconButtonComponent } from '../../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-partners-list',
  templateUrl: './partners-list.component.html',
  styleUrls: ['./partners-list.component.scss'],
  imports: [
    PayeeButtonComponent,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    PayeeIconButtonComponent,
    PayeeIconComponent,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    DatePipe,
  ],
})
export class PartnersListComponent implements OnInit {
  private partnerService = inject(PartnerService);
  private dialog = inject(MatDialog);

  readonly dataSource = new MatTableDataSource<PartnersDataTableItem>();
  readonly displayedColumns: string[] = [
    'integration',
    'name',
    'api_key',
    'origin',
    'created_at',
    'edit',
  ];

  @ViewChild(MatSort) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  async ngOnInit() {
    await this.setDataTable();
  }

  createPartner(): void {
    const ref = this.dialog.open(CreatePartnerDialogComponent, {
      disableClose: true,
    });
    ref.afterClosed().subscribe({
      next: async (result: boolean) => {
        if (!result) {
          return false;
        }

        await this.setDataTable();
      },
    });
  }

  editPartner(element: PartnersDataTableItem): void {
    const ref = this.dialog.open(EditPartnerDialogComponent, {
      data: element,
      disableClose: true,
    });
    ref.afterClosed().subscribe({
      next: async (result: boolean) => {
        if (!result) {
          return false;
        }

        await this.setDataTable();
      },
    });
  }

  private async setDataTable() {
    const result = await this.partnerService.getPartnersDataTable();
    this.dataSource.data = result.data;
  }
}
